export default {"src":"/_next/static/media/logo_small.34930f80.svg","height":228,"width":226,"blurWidth":0,"blurHeight":0};